import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material'
import type { FuturesControlTabConfig } from './futuresControlTabConfig'
import { futuresAccessBaseSx } from './futuresAccessUi'

/**
 * Dải thông tin giống vùng phụ đề form Access: caption + subform name.
 * Mô tả / evidence gấp trong accordion để không chiếm diện tích như datasheet Access.
 */
export default function FuturesTabSummary({ tab }: { tab: FuturesControlTabConfig }) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        border: '1px solid #919B9C',
        bgcolor: '#FFFFFF',
        px: 1,
        py: 0.5,
        ...futuresAccessBaseSx,
      }}
    >
      <Stack direction="row" alignItems="baseline" flexWrap="wrap" columnGap={1} rowGap={0.25}>
        <Typography component="span" sx={{ fontWeight: 700, fontFamily: futuresAccessBaseSx.fontFamily }}>
          {tab.accessLabel}
        </Typography>
        <Typography
          component="span"
          sx={{ color: '#505050', fontFamily: futuresAccessBaseSx.fontFamily, wordBreak: 'break-word' }}
        >
          — {tab.accessForm}
        </Typography>
      </Stack>

      <Accordion
        disableGutters
        elevation={0}
        sx={{
          bgcolor: 'transparent',
          border: 'none',
          '&:before': { display: 'none' },
          '& .MuiAccordionSummary-root': { minHeight: 0, px: 0, py: 0.25 },
          '& .MuiAccordionDetails-root': { px: 0, pt: 0.5, pb: 0 },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}>
          <Typography sx={{ fontSize: '11px', color: '#254061', fontFamily: futuresAccessBaseSx.fontFamily }}>
            Mô tả và tài liệu tham chiếu
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ mb: 0.75, fontFamily: futuresAccessBaseSx.fontFamily }}>{tab.description}</Typography>
          <Typography
            variant="caption"
            sx={{ display: 'block', color: '#404040', mb: 0.25, fontFamily: futuresAccessBaseSx.fontFamily }}
          >
            Actions (Access):
          </Typography>
          <Typography sx={{ mb: 0.75, fontFamily: futuresAccessBaseSx.fontFamily }}>
            {tab.actions.length ? tab.actions.join(' · ') : '—'}
          </Typography>
          <Typography
            variant="caption"
            sx={{ display: 'block', color: '#404040', mb: 0.25, fontFamily: futuresAccessBaseSx.fontFamily }}
          >
            Evidence:
          </Typography>
          <Typography component="ul" sx={{ m: 0, pl: 2.5, fontFamily: futuresAccessBaseSx.fontFamily }}>
            {tab.evidence.map((file) => (
              <li key={file}>
                <Typography component="span" sx={{ fontFamily: futuresAccessBaseSx.fontFamily }}>
                  {file}
                </Typography>
              </li>
            ))}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
